import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/video/user/agentData/stat',
        method: 'get',
        params: query
    })
}
//代理商列表
export function agentlist() {
    return axios({
        url: '/video/user/agent/nameList',
        method: 'get',
    })
}